import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 3% 0 0 0;
  flex-wrap: wrap;

  /* Hide buttons on mobile */
  @media (max-width: 768px) {
    display: none;
  }
`;

export const ToggleButton = styled.button`
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  color: white;
  font-weight: 600;
  font-size: 1rem;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px; /* fixed gap */
  transition: all 0.25s ease;
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);

  &:hover {
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 6px 14px rgba(0,0,0,0.25);
  }
`;

export const ArrowBadge = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 22px;
  height: 22px;
  font-size: 0.8rem;
  transition: transform 0.25s ease;

  ${ToggleButton}:hover & {
    transform: rotate(180deg);
  }
`;

/* Sections Container */
export const SectionsContainer = styled.div`
  margin-top: 1rem;

  /* Mobile: stack Tools + Projects closer together */
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 15px; /* smaller gap so sections look connected */
    
    /* Optional: add padding to make it cozy */
    padding-bottom: 10px;
  }
`;